import { ComponentChildren, ComponentType, h } from "preact";

import CSSProperties from "../../../../foundation/model/CSSProperties";
import classname from "../../../../foundation/utils/classname";
import IconProps from "../../Icons/IconProps";

import styles from "./RightPanelLinkCell.module.css";

interface Props {
    class?: string;
    style?: CSSProperties;
    label: ComponentChildren;
    icon: ComponentType<IconProps>;
    rightContent?: ComponentChildren;
    disabled?: boolean;
    alwaysHighlighted?: boolean;
    onClick?: (event: Event) => void;
}

function RightPanelLinkCell({
    class: cssClass,
    style,
    label,
    icon: Icon,
    rightContent,
    disabled,
    alwaysHighlighted = false,
    onClick
}: Props) {
    return (
        <button
            class={classname(
                "body-1",
                cssClass,
                styles.rightPanelLinkCell,
                { [styles.alwaysHighlighted]: alwaysHighlighted }
            )}
            style={style}
            disabled={disabled}
            onClick={onClick}>
            <div class={styles.iconWrapper}>
                <Icon class={styles.icon}/>
            </div>
            <span class={classname(styles.label, "ellipsis")}>{label}</span>
            {rightContent && (
                <div class={styles.rightContainer}>
                    {rightContent}
                </div>
            )}
        </button>
    );
}

export default RightPanelLinkCell;
